import { RootState } from "@/infrastructure/rootState";

export const sidebarCollapsed = (state: RootState) => state.int.sidebarCollapsed;

export const presentMode = (state: RootState) => state.int.presentMode;

export const isFullScreen = (state: RootState) => state.int.isFullScreen;
